/**
 * @name i18n
 * @description Configuración del framework de traducciones de React
 * @author César Rivera
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';
import { MomentConfig } from '@config';

import { EnglishTranslations } from '@translations/english.translations';
import { PortugueseTranslations } from '@translations/portuguese.translations';
import { SpanishTranslations } from '@translations/spanish.translations';

if (!JSON.parse(localStorage.getItem('ls.ty-Language'))) {
  localStorage.setItem('ls.ty-Language', JSON.stringify({ language: 'es' }));
}

const resources = {
  en: {
    translation: EnglishTranslations
  },
  pt: {
    translation: PortugueseTranslations
  },
  es: {
    translation: SpanishTranslations
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: JSON.parse(localStorage.getItem('ls.ty-Language')).language,
  // keySeparator: false, // we do not use keys in form messages.welcome

  interpolation: {
    escapeValue: false, // react already safes from xss
    format: (value, format) => {
      if (value instanceof Date) return moment(value).format(format);
      return value;
    }
  }
});

MomentConfig.setMomentLocale();

export default i18n;
